function blazeClientHeaderMiddleware(_, { headers = {} }) {
  return {
    headers: {
      ...headers,
      'X-Blaze-Client': process.env.BLAZE_CLIENT_HEADER
    }
  };
}
export default blazeClientHeaderMiddleware;
